exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3eiCpC9oYQt0-J8LXDd69q{color:\"[theme:neutralSecondary, default:#605e5c]\";font-size:11px}html[dir] ._3eiCpC9oYQt0-J8LXDd69q{border-width:1px;border-style:solid;background-color:transparent;border-color:\"[theme:neutralTertiary, default:#a19f9d]\";padding:0 4px 0 4px;text-align:center;border-radius:2px}html[dir=ltr] ._3eiCpC9oYQt0-J8LXDd69q{margin-right:12px}html[dir=rtl] ._3eiCpC9oYQt0-J8LXDd69q{margin-left:12px}", ""]);
// Exports
exports.locals = {
	"typeLabel": "_3eiCpC9oYQt0-J8LXDd69q"
};